import React, { useState } from "react";
import Layout from "../shared/Layout";

{/* https://api.stackexchange.com/docs/questions-by-ids#order=desc&sort=activity&ids=113204&filter=default&site=meta&run=true */}
const Importer: React.FC = () => {
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const extractQuestionIdFromUrl = (url: string): string | null => {
    const regex =
      /^https?:\/\/(?:www\.)?stackoverflow\.com\/questions\/(\d+)\/?/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const handleImport = async () => {
    setLoading(true);
    setError("");

    try {
      // Extract the question ID from the URL
      const questionId = extractQuestionIdFromUrl(url);

      // Fetch the question data from Stack Overflow API
      const response = await fetch(
        `https://api.stackexchange.com/2.3/questions/78206876?order=desc&sort=activity&site=stackoverflow&filter=withbody`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch question data");
      }

      const data = await response.json();
      const question = data.items[0];

      console.log(data);
console.log(question);

      // Extract the relevant information from the question data
      setTitle(question.title);
      setText(question.body);
      setTags(question.tags);
    } catch (error) {
      setError("Error importing question: " + error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div>
        <h1>Import from Stack Overflow</h1>
        <input
          type="text"
          placeholder="Enter Stack Overflow question URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button
          onClick={handleImport}
          disabled={loading}
        >
          {loading ? "Importing..." : "Import"}
        </button>
        {error && <p>{error}</p>}
        {title && (
          <div>
            <h2>{title}</h2>
            <p>{text}</p>
            <p>Tags: {tags.join(", ")}</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Importer;
